import { NuevaAPICobranza } from "../Constants/ApiConnection";
import axios from "axios";
import { toast } from "react-toastify";

export const apiGetPaquetesVPS = async (user, idcontrato) => {
  let url = NuevaAPICobranza + "ordenesServicio/obtenerProductoServicio/?esPaquete=1"
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {


      debugger;
      return response;
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};

export const apiGetPaquetesRelacionadoenVPS = async (user, idcontrato) => {
  let url = NuevaAPICobranza + "contratos/asignar-producto/" + idcontrato;
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {

      return response;
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};

export const apiGetObtenerListasDePrecios = async (user, idcontrato) => {
  let url = NuevaAPICobranza + "ordenesServicio/catalogos/obtenerListaPrecios/"
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {

      return response;
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};


export const apiPatchAsignarProductoServicioVPSaContrato = async (user, idcontrato, idProductoServicio) => {
  let url = NuevaAPICobranza + "contratos/asignar-producto/" + idcontrato + "/" + idProductoServicio + "/";

  debugger;
  try {
    const response = await axios.patch(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {


      debugger;
      return response;
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};

